import React, { useEffect, useState } from 'react';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <>
      {/* Refined Countdown Timer */}
      <div className="fixed top-0 left-0 w-full z-50 flex justify-center pt-3 px-4 pointer-events-none" data-id="element-121">
        <div className="bg-[#1B4332] text-[#FAF7F2] text-xs md:text-sm px-5 py-2 rounded-full shadow-md font-medium tracking-wide pointer-events-auto border border-[#2D5016]/30" data-id="element-122">
          {timeLeft > 0 ? <p className="flex items-center gap-2" data-id="element-123">
              <span className="text-[#D4A853]" data-id="element-124">⏳</span> OFERTA EXPIRA EN:{' '}
              {timeString} <span className="text-[#D4A853] ml-1" data-id="element-125">🔥</span> CUPOS
              LIMITADOS
            </p> : <p className="flex items-center gap-2" data-id="element-126">
              OFERTA EXPIRADA <span className="text-[#D4A853] ml-1" data-id="element-127">🔥</span>{' '}
              CUPOS LIMITADOS
            </p>}
        </div>
      </div>

      <section className="pt-24 pb-16 px-4 bg-[#FAF7F2] flex flex-col items-center text-center relative overflow-hidden" data-id="element-128">
        <div className="max-w-4xl mx-auto w-full" data-id="element-129">
          <div className="animate-[fadeInUp_0.8s_ease-out_forwards]" data-id="element-130">
            <p className="text-sm md:text-base font-medium text-[#2D5016] mb-4 tracking-wide uppercase" data-id="element-131">
              🥗 Para personas que quieren bajar de peso sin dietas extremas
            </p>

            <h1 className="text-5xl md:text-7xl font-bold text-[#1B4332] mb-6 leading-tight tracking-tight" style={{
            fontFamily: "'Playfair Display', Georgia, serif"
          }} data-id="element-132">
              Adelgaza con{' '}
              <span className="text-[#2D5016] italic" data-id="element-133">Airfryer</span>
            </h1>

            <a href="#compra" className="block cursor-pointer mb-8 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/nZ95jkCPiPkKpJs4t465X6/mockup_nuevo.png" alt="Adelgaza con Airfryer MegaPack" className="w-full max-w-xl mx-auto rounded-2xl" fetchPriority="high" decoding="async" width={665} height={1191} sizes="(max-width: 640px) 100vw, 576px" data-id="element-135" />
            </a>

            <h2 className="text-xl md:text-2xl font-medium text-[#1B4332] mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-136">
              El método práctico para bajar de peso comiendo delicioso, rápido y
              sin dietas extremas
            </h2>

            <div className="bg-[#F5F0E8] border border-[#D4A853]/30 rounded-2xl p-4 mb-8 inline-block shadow-sm" data-id="element-137">
              <p className="font-medium text-base md:text-lg text-[#1B4332]" data-id="element-138">
                <span className="text-[#D4A853] mr-2" data-id="element-139">📦</span> MEGAPACK
                COMPLETO — Incluye 6 tomos + 3 bonos exclusivos
              </p>
            </div>

            <p className="text-base md:text-lg text-[#2D5016]/80 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-140">
              Más de 50 recetas saludables, planificación semanal, listas de
              compras y sistema completo para adelgazar sin dejar de disfrutar
              la comida.
            </p>

            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 mb-10 font-medium text-[#1B4332] text-sm md:text-base" data-id="element-141">
              <span className="flex items-center" data-id="element-142">
                <span className="text-[#D4A853] mr-2 text-lg" data-id="element-143">•</span> recetas
                fáciles
              </span>
              <span className="flex items-center" data-id="element-144">
                <span className="text-[#D4A853] mr-2 text-lg" data-id="element-145">•</span>{' '}
                ingredientes económicos
              </span>
              <span className="flex items-center" data-id="element-146">
                <span className="text-[#D4A853] mr-2 text-lg" data-id="element-147">•</span> listo en
                minutos
              </span>
              <span className="flex items-center" data-id="element-148">
                <span className="text-[#D4A853] mr-2 text-lg" data-id="element-149">•</span> ideal
                para principiantes
              </span>
            </div>

            <p className="text-lg font-medium text-[#1B4332] mb-8" style={{
            fontFamily: "'Playfair Display', Georgia, serif"
          }} data-id="element-150">
              Empieza hoy mismo a transformar tu forma de cocinar y de
              alimentarte.
            </p>

            <CTAButton href="#compra" text="QUIERO EL MEGAPACK" data-id="element-151" />

            <div className="mt-8 p-4 bg-[#F5F0E8] rounded-2xl border border-[#FAF7F2] inline-block max-w-md shadow-sm" data-id="element-152">
              <p className="font-medium text-[#1B4332] mb-2 text-sm flex items-center justify-center gap-2" data-id="element-153">
                <span className="text-[#D4A853]" data-id="element-154">🛡️</span> Garantía de
                satisfacción de 7 días
              </p>
              <p className="text-xs text-[#2D5016]/80 leading-relaxed" data-id="element-155">
                Si el método no te ayuda a organizar tu alimentación y cocinar
                más saludable, puedes solicitar la devolución del dinero.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}